/** @module csi/view/ToolbarSimpleSelect */
define([
	"dojo/_base/declare",
	"csi/view/ToolbarPlugin",
	"csi/widget/Select"
], function(declare,ToolbarPlugin,Select) {

	return declare([Select, ToolbarPlugin], {
		/**
		 * @override
		 * Set appearance based on action
		 */
		postMixInProperties: function() {
			if (this.defAction) {
				this._mixinActionProperties();
			}
			
			this.inherited(arguments);
		}
	});
});